export enum EmployeeOffboardingFailureReason {
  EmployeeNotFound = 'employeeNotFound',
  MissingRetirementDate = 'missingRetirementDate',
  OpenTravels = 'openTravels',
}
